import request from '../utils/request'
import qs from 'qs'
export function ikmLogin(token){
    return request({
        url: 'ikm/index.do',
        method: 'post',
        data: qs.stringify({token: token})
    })
}